import React, { useMemo } from 'react';
import Icon from '../../../components/AppIcon';

const DEFAULT_CARDS = [
  {
    id: 1,
    title: 'Total Employees',
    value: '0',
    change: '+0',
    changeType: 'increase',
    icon: 'Users',
    color: 'bg-blue-500',
  },
  {
    id: 2,
    title: 'Present Today',
    value: '0',
    change: '0%',
    changeType: 'neutral',
    icon: 'UserCheck',
    color: 'bg-green-500',
  },
  {
    id: 3,
    title: 'On Leave',
    value: '0',
    change: '0',
    changeType: 'neutral',
    icon: 'Calendar',
    color: 'bg-amber-500',
  },
  {
    id: 4,
    title: 'New Joiners',
    value: '0',
    change: 'This Month',
    changeType: 'neutral',
    icon: 'UserPlus',
    color: 'bg-purple-500',
  },
];

function mapStatsToCards(stats) {
  if (!stats) return null;
  if (Array.isArray(stats)) return stats;
  if (Array.isArray(stats.cards)) return stats.cards;

  const nonTerminated =
    (stats.totalEmployees || 0) - (stats.terminatedEmployees || 0);

  return [
    { ...DEFAULT_CARDS[0], value: String(nonTerminated > 0 ? nonTerminated : stats.totalEmployees || 0) },
    DEFAULT_CARDS[1],
    { ...DEFAULT_CARDS[2], value: String(stats.onLeaveEmployees || 0) },
    DEFAULT_CARDS[3],
  ];
}

const EmployeeStatsCards = ({ stats, loading = false }) => {
  const statsData = useMemo(() => mapStatsToCards(stats) || DEFAULT_CARDS, [stats]);

  const getChangeColor = (type) => {
    switch (type) {
      case 'increase':
        return 'text-green-600';
      case 'decrease':
        return 'text-red-600';
      default:
        return 'text-gray-600';
    }
  };

  const getChangeIcon = (type) => {
    switch (type) {
      case 'increase':
        return 'TrendingUp';
      case 'decrease':
        return 'TrendingDown';
      default:
        return 'Minus';
    }
  };

  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 mb-8">
        <div className="col-span-4 flex justify-center items-center py-8">
          <div className="text-muted-foreground">Loading stats...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 mb-8">
      {statsData.map((stat) => (
        <div key={stat.id} className="bg-card border border-border rounded-lg p-6 hover:shadow-md transition-shadow">
          <div className="flex items-center justify-between mb-4">
            <div className={`${stat.color} p-3 rounded-lg`}>
              <Icon name={stat.icon} size={24} color="white" />
            </div>
            <div className={`flex items-center gap-1 text-sm ${getChangeColor(stat.changeType)}`}>
              <Icon name={getChangeIcon(stat.changeType)} size={16} />
              <span>{stat.change}</span>
            </div>
          </div>
          <div>
            <h3 className="text-2xl font-bold text-foreground mb-1">{stat.value}</h3>
            <p className="text-sm text-muted-foreground">{stat.title}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default EmployeeStatsCards;
